import React, { useState } from "react";
import _ from "lodash";
import api from "../../utils/api";
import {
  _getBaseUrl,
  _getCSRFTokenValue,
  _getTranslation,
} from "../../utils/helper";

import { Loader } from "../../atoms";
import { InputText, SingleCheckbox } from "../../forms";

const StateOfDemocracyContact = (props) => {
  const [values, setValues] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [errors, setErrors] = useState({});
  const [response, setResponse] = useState(null);

  const handleSubmission = async () => {
    setErrors({});
    setResponse(null);

    if (!isTermsAccepted) {
      setErrors({
        terms_error: [
          _getTranslation(
            "please_read_and_agree_to_our_privacy_policy_to_proceed"
          ) + ".",
        ],
      });
      return;
    }

    setIsLoading(true);

    const csrfToken = await _getCSRFTokenValue();
    api
      .post("/form/sodfeedback/submit", values, {
        headers: {
          "X-CSRF-Token": csrfToken,
        },
      })
      .then((res) => {
        setIsLoading(false);
        setResponse(res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        if (err?.data?.errors) {
          setErrors(err.data.errors);
        } else {
          setErrors({
            general_error: ["Something went wrong, please try again."],
          });
        }
      });
  };

  return (
    <React.Fragment>
      {response?.message && _.isString(response.message) ? (
        <p className="font-bold">{response.message}</p>
      ) : (
        <React.Fragment>
          <InputText
            label={`${_getTranslation("name")}*`}
            value={values.name}
            onChange={(e) => {
              setValues({ ...values, name: e.target.value });
            }}
            error={_.get(errors, "name[0]")}
            twoColumnLayout
          />
          <InputText
            label={`${_getTranslation("email")}*`}
            type="email"
            value={values.email}
            onChange={(e) => {
              setValues({ ...values, email: e.target.value });
            }}
            error={_.get(errors, "email[0]")}
            twoColumnLayout
          />
          <InputText
            label={`${_getTranslation("subject")}*`}
            value={values.subject}
            onChange={(e) => {
              setValues({ ...values, subject: e.target.value });
            }}
            error={_.get(errors, "subject[0]")}
            twoColumnLayout
          />
          <InputText
            label={`${_getTranslation("message")}*`}
            type="textarea"
            value={values.message}
            onChange={(e) => {
              setValues({ ...values, message: e.target.value });
            }}
            error={_.get(errors, "message[0]")}
            twoColumnLayout
          />
          <SingleCheckbox
            isTermsCheckbox
            value={isTermsAccepted}
            onChange={(value) => {
              setIsTermsAccepted(value);
            }}
            error={_.get(errors, "terms_error[0]")}
            privacyUrl={props?.data["privacy-url"]}
          />

          {_.get(errors, "general_error[0]") && (
            <div className="text-red-500 font-bold mt-8">
              {_.get(errors, "general_error[0]")}
            </div>
          )}

          <div className="flex items-center gap-x-4 mt-8">
            <button
              className="btn btn-s--pill"
              onClick={() => handleSubmission()}
            >
              {_getTranslation("submit")}
            </button>
            {isLoading && <Loader />}
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default StateOfDemocracyContact;
